import contains from '@/controller/contains'
function _handleScroll() {
  let scrollTop = window.pageYOffset || document.body.scrollTop, toTopshow = false;
  // console.log(scrollTop)
  if(scrollTop > 40){
    toTopshow = true
  }else{
    toTopshow = false
  }
  return toTopshow
}
function fuget(id) {
  console.log('id:', id)
}
//获取屏幕可视区域的宽高
function client(){
  try {
    if(window.innerHeight !== undefined){
      return {
        "width": window.innerWidth,
        "height": window.innerHeight
      }
    }else if(document.compatMode === "CSS1Compat"){
      return {
        "width": document.documentElement.clientWidth,
        "height": document.documentElement.clientHeight
      }
    }else{
      return {
        "width": document.body.clientWidth,
        "height": document.body.clientHeight
      }
    }
  } catch (e) {
    return {
      "width": document.body.clientWidth,
      "height": document.body.clientHeight
    }
  }

}
function product_id_boolean(product_id) {
  const id_list = ['garden_pests', 'multipod_pests', 'storage_pests', 'wet_pests', 'bees', 'woods_pest', 'mite']
  return !id_list.some(item=> {return item == product_id})
}
function product_id_boolean_mobile(product_id) {
  const id_list = ['garden_pests', 'multipod_pests', 'storage_pests', 'wet_pests', 'mite']
  let type = !id_list.some(item=> {return item == product_id})
  return type
}
let event = {
  'event': 'gaGenericEvent'
}
var ga = {
  gaFirst(route){
    var virtualPageTitle  = route.name;
    var virtualPageURL = contains.host + route.path;

    console.log('virtualPageTitle',virtualPageTitle);
    console.log('virtualPageURL',virtualPageURL)
    var data = {
      'event': 'gaGenericPageview',  
      'virtualPageURL': virtualPageURL,
      'virtualPageTitle':  virtualPageTitle,                                                   
      'userCrmId':  window.localStorage.getItem('cid')?window.localStorage.getItem('cid'):" ",
      'userLoginStatus': window.localStorage.getItem('cid')?"Yes":"No",
      'productName': " "
    }
    console.log('ga11',data)
    ga.push(data)
    
  },

  // 404页面
  404: (label) => {
    event.eventCategory = '404 Error';
    event.eventAction = contains.host + '/404';
    event.eventLabel = contains.host + label;
    ga.push(event)
  },
  // 跳转 外链
  outLine: (url) => {
    event.eventCategory = 'Outbound Link';
    event.eventAction = 'Click';
    event.eventLabel = url;
    console.log('ga-外链',event)
    ga.push(event)
  },
  // mobile 菜单
  mobileMain: (action) => {
    event.eventCategory = 'Navigation';
    event.eventAction = action;
    event.eventLabel = 'Main';
    ga.push(event)
    console.log('ga-19',event)
  },
  // mobile 下达菜单
  mainHamburger: (text)=> {
    event.eventCategory = 'Navigation';
    event.eventAction = text;
    event.eventLabel = "Main - Hamburger";
    ga.push(event)
    console.log('ga-20',event)
  },
  sub: (text) => {
    event.eventCategory = 'Navigation';
    event.eventAction = text;
    event.eventLabel = "Sub";
    console.log('ga-21',event)
    ga.push(event)
  },
  footer: (text) => {
    event.eventCategory = 'Navigation';
    event.eventAction = text;
    event.eventLabel = "Footer";
    ga.push(event)
  },
  //ga-27
  openText: (text, action) => {
    event.eventCategory = 'Accordion';
    event.eventAction = action;
    event.eventLabel = text;
    ga.push(event);
    console.log('ga',event)
  },
  cta: (text) => {
    event.eventCategory = 'CTA'
    event.eventAction = 'Click';
    event.eventLabel = text;
    ga.push(event)
    console.log('ga',event)
  },
  quickAppointment: (text) => {
    event.eventCategory = 'Quick Appointment (local)';
    event.eventAction = 'Click';
    event.eventLabel = text;
    ga.push(event)
  },
  // 拨打电话
  customerService: (text) => {
    event.eventCategory = 'Customer Service (local)';
    event.eventAction = 'Click';
    event.eventLabel = text;
    ga.push(event);
    console.log('ga',event)
  },
  // carousel: (text, label) => {
  //   event.eventCategory = 'Carousel';
  //   event.eventAction = 'Click - ' + text;
  //   event.eventLabel = label;
  //   ga.push(event)
  // },
  engagement: () => {
    event.eventCategory = 'Engagement';
    event.eventAction = '20 seconds';
    event.eventLabel = 'Adjusted Bounce Rate';
    ga.push(event)
  },
  carousel: (action, label) => {
    event.eventCategory = 'Carousel';
    event.eventAction = action;
    event.eventLabel = label;
    ga.push(event)
    console.log('carousel',event)
  },
  slider: (action, label) => {
    event.eventCategory = 'Slider (local)',
    event.eventAction = action;
    event.eventLabel = label;
    ga.push(event)
  },
  push: (data) => {
    // console.info(JSON.stringify(data))

    // window.dataLayer.push(data)
    // console.log('window')
  },

  //首页增强电商-商品信息ga-73
  commodityEnhanced(){
    var data = {
      'event': 'ecProductImpression',
      'ecommerce': {
        'currencyCode': 'CNY',
        'impressions': [
          {
            'name': '白蚁灭治',
            'id': '',
            'category': '',
            'price': '',
            'position': 1,
            'dimension102': 'termite_treatment',
            'dimension108': '白蚁灭治',
            'dimension109': 'Termite Treatment'

          },
          {
            'name': '蟑螂拜拜',
            'id': '',
            'category': '',
            'price': '',
            'position': 2,
            'dimension102': 'cockroach',
            'dimension108': '蟑螂拜拜',
            'dimension109': 'Cockroaches'

          },
          {
            'name': '老鼠拜拜',
            'id': '',
            'category': '',
            'price': '',
            'position': 3,
            'dimension102': 'rats',
            'dimension108': '老鼠拜拜',
            'dimension109': 'Rats'
          }
        ]}
    }
    console.log('ga-73',data);
    ga.push(data)
  },
  //ga-95
  sliderDirection(data){
    var text = {
      'event': 'gaGenericEvent',
      'eventCategory': 'Slider (local)',
      'eventAction': data,
      'eventLabel': 'Client Testimonial'
    }
    console.log('ga-95',text)
    ga.push(text);
  }
}

export default {
  handleScroll: _handleScroll,
  fuget: fuget,
  client: client,
  product_id_boolean:product_id_boolean,
  product_id_boolean_mobile: product_id_boolean_mobile,
  ga: ga
}



// WEBPACK FOOTER //
// ./src/controller/utils.js